var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPreference(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3200,
    height: 1800,
    viewBox: "0 0 3200 1800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1588,
    y: 298,
    width: 435,
    height: 120,
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1588,
    cy: 358,
    r: 60,
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 325,
    height: 120,
    transform: "matrix(-1 0 0 1 2264 658)",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 60,
    transform: "matrix(-1 0 0 1 2264 718)",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 120,
    transform: "matrix(-1 0 0 1 2074 838)",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 60,
    transform: "matrix(-1 0 0 1 2074 898)",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1748,
    y: 478,
    width: 275,
    height: 120,
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1748,
    cy: 538,
    r: 60,
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1698,
    y: 1018,
    width: 342,
    height: 120,
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1698,
    cy: 1078,
    r: 60,
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1263.12 412.183C1289.39 461.156 1286.27 585.379 1252.32 594.132C1238.77 597.622 1209.93 589.072 1180.57 571.376L1198.99 701.754H1090.18L1127.64 527.145C1106.75 502.623 1092.61 472.57 1094.97 438.895C1101.78 341.865 1236.85 363.21 1263.12 412.183Z",
    fill: "#EAC7A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1099.28 418.304C1121.71 310.367 1267.19 375.631 1295.21 358.196C1301.33 395.654 1281.29 425.769 1210.76 419.064C1197.86 428.249 1188.04 443.532 1176.27 462.98C1173.45 461.989 1170.41 461.451 1167.26 461.451C1152.23 461.451 1140.05 473.631 1140.05 488.655C1140.05 496.131 1143.07 502.903 1147.95 507.82C1141.73 516.804 1134.77 526.185 1126.81 535.86C1098.37 518.35 1076.8 469.233 1098.57 419.881L1099.28 418.304Z",
    fill: "#4A312C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1053.91 1078.08L1218.29 1654.93L1338.22 2080.1H1425.7L1298.25 1078.08H1053.91Z",
    fill: "#56919C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1009.94 1078.08C1006.14 1375.39 993.177 1537.56 989.185 1564.57C985.193 1591.58 924.831 1763.43 808.099 2080.1H898.717C1047.33 1776.31 1130.28 1604.46 1147.59 1564.57C1164.9 1524.68 1218.3 1362.51 1298.74 1078.08H1009.94Z",
    fill: "#89C5CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1426.18 915.618L1570.81 1021.82C1610.04 1032.41 1642.81 1045.58 1669.13 1061.33C1675.34 1066.99 1682.86 1078.47 1657.07 1076.48C1631.29 1074.5 1604.08 1073.57 1600.53 1082.37C1596.97 1091.16 1612.57 1101.68 1605.38 1113.54C1600.58 1121.45 1577.94 1101.62 1537.43 1054.04L1394.21 994.651L1426.18 915.618ZM1708.8 525.033C1691.7 544.431 1674.58 565.604 1679.46 573.737C1684.35 581.871 1702.13 575.739 1707.28 588.623C1710.72 597.213 1681.24 603.365 1618.87 607.079L1485.25 685.718L1441.37 612.621L1613.23 561.031C1645.29 536.074 1675.53 517.826 1703.95 506.288C1712.21 504.732 1725.89 505.636 1708.8 525.033Z",
    fill: "#EAC7A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1201.54 629.607C1280.3 776.462 1394.19 889.037 1559.29 1006.06L1496.78 1076.55C1312.43 1008.04 1215.13 966.71 1167.35 827.961C1155.36 793.138 1146.98 682.129 1139.79 623.722L1201.54 629.607Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M981.361 1118.89H1330.48C1251.4 877.699 1211 712.164 1209.29 622.28C1209.2 617.698 1200.74 609.623 1196.99 610.68C1169.61 618.413 1140.31 615.522 1109.09 602.006C1026.33 735.118 997.706 899.006 981.361 1118.89Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1588.57 561.199L1607.06 653.573C1465.53 744.594 1322.23 815.103 1196.66 805.088C1251.19 1038.98 1248.68 1230.45 1128.3 1230.45H942.147C912.582 1031.76 990.285 756.27 1062.32 617.315C1065.07 612.009 1070.93 602.006 1084.72 602.006H1138.81C1138.84 602.078 1138.86 602.151 1138.89 602.223C1238.96 603.04 1401.32 621.314 1588.57 561.199Z",
    fill: "#ECECEC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1608.08,
    y1: 358,
    x2: 1965.69,
    y2: 358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D72FE",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D72FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 15.0056,
    y1: 60.0001,
    x2: 282.179,
    y2: 60.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D72FE",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D72FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 6.23311,
    y1: 60.0001,
    x2: 117.213,
    y2: 60.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D72FE",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D72FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 1760.7,
    y1: 538,
    x2: 1986.77,
    y2: 538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D72FE",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D72FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 1713.79,
    y1: 1078,
    x2: 1994.94,
    y2: 1078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D72FE",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D72FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3200,
    height: 1800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPreference);
export default __webpack_public_path__ + "static/media/work-preference.4215281e4f9c0887a7c3767b952975d5.svg";
export { ForwardRef as ReactComponent };